
import { tagableMixin } from "~/mixins";

export default {
  mixins: [tagableMixin],

  inject: { priorityCampaign: { default: { value: null } } },

  props: {
    product: { type: Object, required: true },
    selectedVariant: { type: Object, required: true },
  },

  computed: {
    tags() {
      return this.product?.tags ?? [];
    },
    quickship() {
      return this.selectedVariant?.quickship ?? false;
    },
    icons() {
      return {
        saleTagText: this.priorityCampaign.value?.saleTileTitle,
        saleTagBgColor: this.priorityCampaign.value?.saleColor ?? "",
        isExclusive: this.isExclusive,
        isReadyToShip: this.isReadyToShip,
        isCustomisable: this.isCustomisable,
        quickship: this.quickship,
      };
    },
    showIcons() {
      return Object.values(this.icons).filter(icon => icon != null).length > 1;
    },
  },
};
